/**
 * Cesium Draw Event Type
 */
export enum DrawEventType {
  /**
   * MouseMove Event
   */
  CursorUpdate = 'cursor-update',
  /**
   * Draw Complete Event
   */
  Complete = 'complete',
  /**
   * Vertex added Event
   */
  VertexAdd = 'vertex-add',
}
